import noonConfig from '../../noon/noonConfig';
import kulConfig from '../../kul/kulConfig';
import sivviConfig from '../../sivvi/sivviConfig';

import { MARKETPLACE } from '../baseConfig';

import { TMarketplace, TMarketplaceConfig } from '../types/config';

const MARKETPLACE_CONFIGS: { [TConfig in TMarketplace]: TMarketplaceConfig } = {
    noon: noonConfig,
    kul: kulConfig,
    sivvi: sivviConfig,
};

export const MARKETPLACE_CONFIG = MARKETPLACE_CONFIGS[MARKETPLACE];

export const getMarketplaceConfig = (marketplace: TMarketplace): TMarketplaceConfig => MARKETPLACE_CONFIGS[marketplace];
